<div class="pdf-bar">
    <label>Export full view to</label>
    <div class="spacer"></div>
    <cc-button [type]="'outline'" (pressed)="exportPDF.emit()">PDF</cc-button>
</div>

<div class="excel-bar">
    <div class="labeled-toggle">
        <label>Export Data</label>
        <div class="spacer"></div>
        <cc-option-toggle
            class="filtered-export-toggle"
            [labels]="{ trueLabel: 'Filtered', falseLabel: 'Full' }"
            [(value)]="filteredExport"
        >
        </cc-option-toggle>
    </div>

    @if (hasCrosstalkData) {
        <div class="labeled-toggle">
            <label>Crosstalk keys</label>
            <div class="spacer"></div>
            <cc-option-toggle
                class="crosstalk-keys-toggle"
                [labels]="{ trueLabel: 'Excluded', falseLabel: 'Included' }"
                [(value)]="excludeCrosstalkKeys"
            >
            </cc-option-toggle>
        </div>
    }

    <div class="widgets-wrapper">
        <cc-checkbox
            class="select-all-cb"
            [label]="'Select All'"
            [(value)]="allWidgetsSelected"
            (valueChange)="onSelectAllToggled($event)"
        >
        </cc-checkbox>
        @for (widget of widgetOptions; track widget.id) {
            <cc-checkbox
                class="widget-cb"
                [label]="widget.name"
                [(value)]="widget.selected"
                (valueChange)="onToggleWidget(widget.id, $event)"
            >
            </cc-checkbox>
        }
    </div>

    <div class="button-bar">
        <cc-button
            class="csv-button"
            [type]="'outline'"
            [disabled]="hasNoSelectedWidgets"
            (pressed)="emitExcelExport('CSV')"
        >
            CSV
        </cc-button>

        <cc-button
            class="excel-button"
            [type]="'outline'"
            [disabled]="hasNoSelectedWidgets"
            (pressed)="emitExcelExport('EXCEL')"
        >
            Excel
        </cc-button>
    </div>
</div>
